import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

const ParallaxText = ({ 
  children, 
  speed = 0.5, 
  className = "",
  direction = "up", // "up", "down", "left", "right"
  ...props 
}) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });

  // Create transforms based on direction
  const yTransform = useTransform(scrollYProgress, [0, 1], [0, direction === "down" ? speed * 100 : -speed * 100]);
  const xTransform = useTransform(scrollYProgress, [0, 1], [0, direction === "right" ? speed * 100 : -speed * 100]);

  const transform = (direction === "left" || direction === "right") ? xTransform : yTransform;

  const getMotionStyle = () => {
    if (direction === "left" || direction === "right") {
      return { x: transform };
    }
    return { y: transform };
  };

  return (
    <motion.div
      ref={ref}
      style={getMotionStyle()}
      className={className}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default ParallaxText;